export const objectDefault = {
  // qs_id: 4,

  qs_categoria: "",
  qs_parametro: "",
  qs_usuario: "",
  qs_empresa: "",
  qs_fec_reg: "",
};

export const columns = [
  {
    id: "qs_categoria",
    label: "Categoria",
    minWidth: 25,
    tipo: "string",
    propiedad: "qs_categoria",
  },
  {
    id: "qs_parametro",
    label: "Parametro",
    minWidth: 25,
    tipo: "string",
    propiedad: "qs_parametro",
  },
  {
    id: "qs_usuario",
    label: "User",
    minWidth: 25,
    tipo: "string",
    propiedad: "qs_usuario",
  },
  {
    id: "qs_fec_reg",
    label: "Fec. Reg.",
    minWidth: 25,
    tipo: "string",
    propiedad: "qs_fec_reg",
  },
];
